import { List, Search, ThemesNames } from '@silverfort/sf-components';
import useEntitiesSearch from '../../../../common/Entities/EntitiesSearchHook';
import { useCallback, useMemo, useState, useRef, useEffect } from 'react';
import * as EntitiesUtils from '../../../../common/Entities/EntitiesUtils';
import { Entity } from '../../../../common/Entities/EntitiesTypes';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';

const borderStyle =
    'p-[1px] bg-transparent focus-within:bg-gradient-to-r focus-within:from-[#FFBE01] focus-within:to-[#FF7F3E] rounded-lg transition-all duration-200';

const EntitySearch = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const searchRef = useRef<HTMLDivElement>(null);
    const entityTypes = useMemo(
        () => [
            AD_ENTITY_TYPES.USER,
            AD_ENTITY_TYPES.HOST,
            AD_ENTITY_TYPES.SERVER,
            AD_ENTITY_TYPES.GROUP,
            AD_ENTITY_TYPES.OU
        ],
        []
    );
    const { entities, isLoading } = useEntitiesSearch(searchQuery, entityTypes, false);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
                setSearchQuery('');
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const onSearch = useCallback((query: string) => {
        setSearchQuery(query);
    }, []);

    const onSelect = useCallback((entity?: Entity) => {
        if (!entity) {
            return;
        }
        window.location.href = `/Inventory?investigateGuid=${entity.guid}&investigateAdType=${entity.type}`;
    }, []);

    const entitiesItems = useMemo(() => {
        return EntitiesUtils.mapEntitiesToItems(entities, {
            onClick: onSelect,
            theme: ThemesNames.Dark
        });
    }, [entities, onSelect]);

    return (
        <div className="relative" ref={searchRef}>
            <div className={borderStyle}>
                <Search text={searchQuery} theme={ThemesNames.Dark} onChange={onSearch} />
            </div>
            {!entities.length && !!searchQuery && !isLoading && (
                <div className="absolute top-[calc(100%+8px)] left-0 w-full h-[56px] items-center justify-center flex bg-sf-gray-1000 border border-sf-gray-800 rounded-lg z-[10] text-sf-gray-400 text-xs">
                    No results found
                </div>
            )}
            {!!entitiesItems.length && (
                <div
                    className="absolute top-[calc(100%+8px)] left-0 w-full max-h-[248px] overflow-y-auto rounded-lg z-[10]"
                    style={{
                        scrollbarWidth: 'thin',
                        scrollbarColor: '#4D4D4D #1A1919'
                    }}>
                    <List theme={ThemesNames.Dark}>{entitiesItems}</List>
                </div>
            )}
        </div>
    );
};

export default EntitySearch;
